/* eslint-disable quotes */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from "react";
import { GrFormClose } from "react-icons/gr";
import {
  ContainerModal,
  Footer,
  Header,
  TitleHeader,
  ButtonClose,
  DialogHeader,
  ButtonSave,
  Modal,
  Divider,
  IconButton,
  CircularProgress,
} from "./styles";

interface Props {
  open: boolean;
  setOpenModal: any;
  component?: JSX.Element;
  title: string;
  saveText: string;
  closeText: string;
  onClose: Function;
  onClean?: Function;
  onSave: Function;
  isRight?: boolean;
  width?: number;
  loading?: boolean;
  isFilter: boolean;
  isClose?: boolean;
}

const DialogCommon: React.FC<Props> = ({
  open,
  setOpenModal,
  component,
  title,
  closeText,
  saveText,
  onClose,
  onSave,
  isRight,
  width,
  loading,
  isFilter,
  isClose,
}) => (
  <Modal
    PaperProps={{
      style: {
        borderRadius: 18,
        position: isRight ? "absolute" : "unset",
        top: isRight ? 40 : 0,
        right: isRight ? 10 : 0,
        display: "flex",
      },
    }}
    open={open}
    onClose={() => {
      setOpenModal(false);
      onClose();
    }}
  >
    <DialogHeader>
      <Header>
        <TitleHeader>{title}</TitleHeader>
        <IconButton
          onClick={() => {
            onClose();
            setOpenModal(false);
          }}
        >
          <GrFormClose />
        </IconButton>
      </Header>
    </DialogHeader>
    <Divider />
    <ContainerModal style={{ width: width || 500 }}>{component}</ContainerModal>
    <Footer>
      {isFilter ? (
        <ButtonClose
          disabled={loading}
          onClick={() => {
            onClose();
          }}
        >
          {closeText}
        </ButtonClose>
      ) : (
        <>
          {isClose && !loading && (
            <ButtonClose
              onClick={() => {
                onClose();
                setOpenModal(false);
              }}
            >
              {closeText}
            </ButtonClose>
          )}
        </>
      )}
      <ButtonSave disabled={loading} onClick={() => onSave()}>
        {loading ? <CircularProgress color="inherit" size={18} /> : saveText}
      </ButtonSave>
    </Footer>
  </Modal>
);
export default DialogCommon;
